import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import KonfiguratorPage from "@/pages/KonfiguratorPage";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import NotFound from "@/pages/NotFound";
import { SERVICES } from "@/data/services";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/konfigurator" element={<KonfiguratorPage />} />
            {SERVICES.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage />} />
            ))}
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </SmoothScroll>
        <Toaster position="top-center" theme="dark" richColors />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
